module.exports = __webpack_public_path__ + "img/twitter.b202c02b.svg";